import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import * as styles from './styles';

const Container = glamorous.div(styles.Container);

class ButtonGroup extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  getButtonStyle(index) {
    const childrenLength = this.props.children.length - 1;

    return {
      minWidth: 'auto',
      flex: 1,
      borderTopLeftRadius: index > 0 ? 0 : undefined,
      borderTopRightRadius: index < childrenLength ? 0 : undefined,
      borderBottomRightRadius: index < childrenLength ? 0 : undefined,
      borderBottomLeftRadius: index > 0 ? 0 : undefined,
      borderLeftWidth: index > 0 ? 1 : undefined,
      borderRightWidth: index < childrenLength ? 1 : undefined,
    };
  }

  renderButton = (button, index) => React.cloneElement(button, {
    style: {
      ...button.props.style,
      ...this.getButtonStyle(index),
    },
  });

  render() {
    return (
      <Container>
        {React.Children.map(this.props.children, this.renderButton)}
      </Container>
    );
  }
}

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/ui/ButtonGroup/ButtonGroup.js